// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-issue-mark {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: inline-block;\n  vertical-align: middle;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
